import {
	GridColumnMenuColumnsItem,
	GridColumnMenuContainer,
	GridColumnMenuProps,
	GridColumnMenuSortItem,
} from "@mui/x-data-grid";

interface CustomColumnMenuProps extends GridColumnMenuProps {
	disableSort?: boolean;
}

export function CustomColumnMenu(props: CustomColumnMenuProps) {
	const { hideMenu, colDef, open, disableSort } = props;

	if (!colDef) return null;

	return (
		<GridColumnMenuContainer open={open} hideMenu={hideMenu} colDef={colDef}>
			{/* Sort item */}
			{!disableSort && <GridColumnMenuSortItem onClick={hideMenu} colDef={colDef} />}

			{/* Columns item */}
			<GridColumnMenuColumnsItem onClick={hideMenu} colDef={colDef} disableHideAll disableShowAll />
		</GridColumnMenuContainer>
	);
}
